import ServiceHighlights from "reusables/sections/ServiceHighlights";

const items = [
  {
    icon: "emergency",
    title: "Emergency Response",
    description:
      "We coordinate fast response to urgent issues — leaks, heating failures, security — minimising damage and disruption to tenants.",
  },
  {
    icon: "engineering",
    title: "Vetted Contractors",
    description:
      "We work with a network of trusted, vetted tradespeople to ensure repairs are carried out to a high standard at competitive rates.",
  },
  {
    icon: "chat",
    title: "Tenant & Landlord Communication",
    description:
      "We handle communication between tenants and contractors, keeping landlords informed throughout without requiring their direct involvement.",
  },
  {
    icon: "receipt_long",
    title: "Transparent Reporting",
    description:
      "We provide clear records of all repair work carried out, including costs and contractor details, for full transparency.",
  },
];

function ReactiveRepairs_Section1() {
  return (
    <ServiceHighlights
      title="Why Choose Our Reactive Repairs & Emergency Response?"
      items={items}
    />
  );
}

export default ReactiveRepairs_Section1;
